
<template>
  <ul class="ul_icons ul_bg flex25">
    <li class="cloud_platform" v-for="item in blocks" :key="item.id">
      <div class="div_img">
        <img :src="item.bgimg" alt="" />
      </div>
      <span
        ><p>{{ item.title }}</p>
      </span>
      <div class="div_fix">
        <img :src="item.imgbz" alt="" />
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    blocks: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style>
.flex25{
  flex-wrap: wrap;
}
.role .ul_icons li {
  margin-bottom: 50px;
  width: 20%;
  cursor: pointer;
  align-items: flex-start;
}
/* .role .ul_icons li:nth-child(n+5) {
  width: 20%;
  cursor: pointer;
} */
</style>
